<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<breadcrumbs
			:breadcrumbs="page.breadcrumbs"
			:class="page.headingImage ? '' : 'no-slider'"
			:home="defaults[locale].website.hotelName"
		/>

		<main-content :title="page.title || page.header" :content="page.content" />

		<section class="main-content background-color">
			<div id="news-container" class="row news">
				<div v-for="item in newsPaginated" :key="item.ID" class="columns column12">
					<div class="news-block">
						<div class="news-image left">
							<nuxt-link :to="localePath(`/${item.filename}`)">
								<picture>
									<source
										v-if="item.overviewImageWebp"
										:srcset="item.overviewImageWebp"
										type="image/webp"
									/>
									<source :srcset="item.overviewImage" />
									<img loading="lazy" :src="item.overviewImage" :alt="item.overviewImageAlt" />
								</picture>
							</nuxt-link>
						</div>
						<div class="news-content left">
							<h3>{{ item.title || item.header }}</h3>
							<p>
								<strong>{{ $d(new Date(item.date.date.split(' ')[0]), 'short') }}</strong>
							</p>
							<div v-parse-links v-html="item.overviewContent" />
							<nuxt-link class="button button-no-fill" :to="localePath(`/${item.filename}`)">
								{{ $t('readMore') }}
							</nuxt-link>
						</div>
					</div>
				</div>
				<div v-if="news.length > newsPaginated.length" id="showMoreNews" class="row align-center">
					<a class="button" href="#" @click.prevent="currentPage++">
						{{ $t('readMore') }}
					</a>
				</div>
			</div>
		</section>

		<contentblocks v-if="page.contentblocks && page.contentblocks.length" :items="page.contentblocks" />

		<review-slider v-if="page.showReviewSlider" :header="defaults[locale].website.reviewsHeader" />
		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:header="page.frequentlyAskedQuestion.header"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>
		<pre-footer v-if="page.footerSection.length" :footer-section="page.footerSection[0]" />
		<newsletter
			v-if="page.showNewsletter"
			:header="defaults[locale].website.newsletterHeader"
			:content="defaults[locale].website.newsletterContent"
			:button="defaults[locale].website.newsletterButton"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();
const localePath = useLocalePath();

await fetchPage();
await fetchDefaults();

const currentPage = ref(1);
const itemsPerPage = 3;

const { data: news } = await useWebsiteFetch('news', {
	query: { language: locale.value },
	key: `${locale.value}/news`,
});

const newsPaginated = computed(() => news.value.slice(0, currentPage.value * itemsPerPage));
</script>

<style lang="scss">
.news {
	.column12 {
		padding: 40px;
		background: #fff;
		margin: 0 auto 40px;
		box-shadow: 0 0 20px rgb(0 0 0 / 5%);
	}

	.news-block,
	.news-block:hover {
		color: #000;
	}

	.news-block {
		span,
		h3 {
			color: $cta-color;
		}

		p,
		h3 {
			margin: 0 0 10px;
		}

		.news-image {
			padding: 0 20px 0 0;
			max-width: 30%;
		}

		.news-content {
			padding: 0 20px;
			max-width: 70%;
		}
	}
}

@media (max-width: 768px) {
	.news {
		.column12 {
			padding: 20px;
		}

		.news-block {
			.news-content {
				max-width: 100%;
			}

			.news-image {
				max-width: 100%;
				padding: 20px;
			}
		}
	}
}
</style>
